<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    maxWidth="800"
    :title="modal.title"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-form class="my-5">
      <v-text-field
        v-model="alert.description"
        v-bind:label="$t('Description')"
        :error-messages="descriptionErrors"
        @input="$v.alert.description.$touch()"
        @blur="$v.alert.description.$touch()"
      ></v-text-field>

      <BaseDatePicker v-model="alert.date" :label="$t('Date')" />

      <v-switch
        style="position: absolute"
        v-bind:label="$t('NotifyByEmail')"
        input-value="true"
        v-model="alert.notifyByEmail"
      />
    </v-form>
  </base-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import AlertService from "@/services/AlertService";
import Alert from "@/ecm/models/search/results/list/Alert";
import Utils from "@/ecm/common/Utils";

export default {
  data() {
    return {
      alert: new Alert(),
      modal: {
        title: this.$t("Alerts"),
        key: "alertModal",
      },
      open: false,
    };
  },
  mixins: [validationMixin],
  validations: {
    alert: {
      description: { required },
    },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.alert.description.$dirty) return errors;
      !this.$v.alert.description.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.modalInstance.progress(true);

      AlertService.save(this.alert.toDto())
        .then((result) => {
          if (result) {
            this.hide();
            this.$emit("on-alert-saved");
          }
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    new(documentId) {
      this.$v.$reset();
      this.alert = new Alert();
      this.alert.documentId = documentId;
      this.alert.date = Utils.date.now();
      this.show();
    },
    edit(alert) {
      this.alert = Utils.object.clone(new Alert(), alert);
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>
